import { checkPermission } from '@/router/guards.ts'

const ContentModule = () => import('./ContentModule.vue')
const ContentIndex = () => import('./views/ContentIndex.vue')

export const contentRoute = {
  path: '/contents',
  name: 'content',
  component: ContentModule,
  meta: {
    requiresAuth: true,
    keepAlive: true,
    title: 'Contents',
  },
  children: [
    {
      path: '',
      name: 'contents-index',
      component: ContentIndex,
      meta: {
        permission: 'station_content.view',
      },
      beforeEnter: checkPermission('station_content.view'),
    },
  ],
}
